//
//
//
//
//
//

export default {
  name: "CellComponent",
  props: {
    type: {
      // text:纯文字，primary:文字白色其余地方主题侧 border:边框字体主题色其余透明
      type: String,
      default: "text",
    },
    active: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    computedClass() {
      return {
        primary: this.type === "primary",
        lock: !this.active,
        border: this.type === "border",
      };
    },
  },
  methods: {
    btnClick() {
      if (this.active) {
        this.$emit("click");
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/button/Index.vue